import React from 'react';

import { NavContext } from '../contexts/NavContext';

export interface FmlRouteProps {
  path?: string;
  exact?: boolean;
  show?: boolean;
  render: (props?: any) => JSX.Element; // TODO(FW-2959): type
  disableFmlPageManagement?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface FmlRouteState {}

export class FmlRoute extends React.PureComponent<FmlRouteProps, FmlRouteState> {
  context!: React.ContextType<typeof NavContext>;

  render() {
    const FmlRouteInner = this.context.getFmlRoute();

    if (!this.context.hasFamilyRouter() || !FmlRoute) {
      console.error(
        'You either do not have an Family Router package, or your router does not support using <FmlRoute>'
      );
      return null;
    }

    return <FmlRouteInner {...this.props} />;
  }

  static get contextType() {
    return NavContext;
  }
}
